import React from "react";
import Spinner from "../Spinner";

function SpinnerButton({ isLoading, children, ...props }) {
  // const btnText = text || 'Button';
  return (
    <button className="btn btn-primary" type="button" {...props}>
      {isLoading ? <Spinner /> : children}
    </button>
  );
}

export default SpinnerButton;
